var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "register-shipping-info-modal",
          role: "dialog",
          "data-backdrop": "static",
          "data-keyboard": "false"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-lg",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-body" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "form-register p-xl" }, [
                  _c("form", [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "name" } }, [
                        _vm._v("発送元名（企業名、氏名など）")
                      ]),
                      _c("span", { staticClass: "label-required" }, [
                        _vm._v("必須")
                      ]),
                      _vm._v(" 全角16文字以内\n                "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.formRegisterData.name,
                            expression: "formRegisterData.name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "name" },
                        domProps: { value: _vm.formRegisterData.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.formRegisterData,
                              "name",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "postalcode" } }, [
                        _vm._v("郵便番号")
                      ]),
                      _c("span", { staticClass: "label-required" }, [
                        _vm._v("必須")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.formRegisterData.postalCode,
                                expression: "formRegisterData.postalCode",
                                modifiers: { trim: true }
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "postalcode",
                              placeholder: "ハイフンなし"
                            },
                            domProps: {
                              value: _vm.formRegisterData.postalCode
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formRegisterData,
                                  "postalCode",
                                  $event.target.value.trim()
                                )
                              },
                              blur: function($event) {
                                _vm.$forceUpdate()
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary custom-btn-delivery check-maintenance",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.searchAddressByPostalCode()
                                }
                              }
                            },
                            [_vm._v("住所検索")]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "address" } }, [
                        _vm._v("住所1")
                      ]),
                      _c("span", { staticClass: "label-required" }, [
                        _vm._v("必須")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box-input-address" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.formRegisterData.address1,
                              expression: "formRegisterData.address1",
                              modifiers: { trim: true }
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "address",
                            autocomplete: "off"
                          },
                          domProps: { value: _vm.formRegisterData.address1 },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formRegisterData,
                                  "address1",
                                  $event.target.value.trim()
                                )
                              },
                              function($event) {
                                _vm.handleChangeAddress()
                              }
                            ],
                            focus: function($event) {
                              _vm.handleFocusAddress()
                            },
                            blur: [
                              function($event) {
                                _vm.handleBlurAddress()
                              },
                              function($event) {
                                _vm.$forceUpdate()
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _vm.showAddressList
                          ? _c("div", { staticClass: "box-address-list" }, [
                              _c(
                                "ul",
                                { staticClass: "address-list list-group" },
                                _vm._l(_vm.addressList, function(
                                  address,
                                  addressIndex
                                ) {
                                  return _c(
                                    "a",
                                    {
                                      key: addressIndex,
                                      class: [
                                        "address-item list-group-item list-group-item-action",
                                        _vm.formRegisterData.address1 ===
                                        address
                                          ? "active"
                                          : ""
                                      ],
                                      attrs: { href: "javascript:void(0)" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          _vm.chooseAddressItem(address)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(address))]
                                  )
                                }),
                                0
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v("※住所検索時は続きをご入力ください")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "address" } }, [
                        _vm._v("住所2（住所1のつづき）")
                      ]),
                      _c("span", { staticClass: "label-any" }, [
                        _vm._v("任意")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box-input-address" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.formRegisterData.address2,
                              expression: "formRegisterData.address2",
                              modifiers: { trim: true }
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "address",
                            autocomplete: "off"
                          },
                          domProps: { value: _vm.formRegisterData.address2 },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formRegisterData,
                                  "address2",
                                  $event.target.value.trim()
                                )
                              },
                              function($event) {
                                _vm.handleChangeAddress()
                              }
                            ],
                            focus: function($event) {
                              _vm.handleFocusAddress()
                            },
                            blur: [
                              function($event) {
                                _vm.handleBlurAddress()
                              },
                              function($event) {
                                _vm.$forceUpdate()
                              }
                            ]
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "phone-number" } }, [
                        _vm._v("電話番号")
                      ]),
                      _c("span", { staticClass: "label-required" }, [
                        _vm._v("必須")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.formRegisterData.phoneNo,
                            expression: "formRegisterData.phoneNo",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "phone-number" },
                        domProps: { value: _vm.formRegisterData.phoneNo },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.formRegisterData,
                              "phoneNo",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center m-t-lg" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-basic custom-btn-delivery m-r-sm",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: {
                            click: function($event) {
                              _vm.$emit("close")
                            }
                          }
                        },
                        [_vm._v("閉じる")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-warning custom-btn-delivery check-maintenance",
                          attrs: {
                            type: "button",
                            disabled: _vm.disabledSubmit
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.handleSubmit()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.submitText))]
                      )
                    ])
                  ])
                ])
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "m-t-none m-b-none" }, [
      _c("strong", [_vm._v("発送元情報登録")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d7de4c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d7de4c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/components/RegisterShippingInfoModal.vue
// module id = null
// module chunks = 